import React from 'react'
import classnames from 'classnames'
import { string, bool } from 'prop-types'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const CardImage = ({ disabled, imgSrc, imgAlt, height, rounded, overlay }) => {
  const classNameVal = classnames('campus-card-img', {
    'campus-card-img--rounded': rounded,
    disabled,
    overlay,
  })
  const overlayText = overlay === 'closed' && 'Pendaftaran Ditutup'
  return (
    <div className={classNameVal}>
      <Relazsizes
        dataSrc={imgSrc || `${assetsUrl}/assets/img/placeholder_school_card.jpg`}
        alt={imgAlt}
      />
      {
        overlay &&
        <div className="campus-card-img__overlay">
          <div className="campus-card-img__overlay-text">
            {overlayText}
          </div>
        </div>
      }

      <style jsx>
        {`
          .campus-card-img {
            margin: -1rem;
            margin-bottom: unset;
            :global(img) {
              width: 100%;
              height: ${height || '202px'};
              object-fit: cover;
              object-position: center center;
            }
            &.campus-card-img--rounded {
              :global(img) {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
              }
            }
            &.disabled {
              :global(img) {
                filter: grayscale(1);
              }
            }
            &.overlay {
              position: relative;
              :global(img) {
                opacity: .55;
              }
            }
            &__overlay {
              position: absolute;
              z-index: 1;
              margin: 0 auto;
              left: 0;
              right: 0;        
              text-align: center;
              top: 41%;
            }
            &__overlay-text {
              border-radius: 18px;
              background-color: #6b8fbc;
              padding: 5px;
              margin: 0px 58px;
              color: #fff;
              font-size: 14px;
              font-weight: bold;
            }
          }
        `}
      </style>
    </div>
  )
}

CardImage.propTypes = {
  disabled: bool,
  imgSrc: string,
  imgAlt: string,
  height: string,
  rounded: bool,
  overlay: string,
}

CardImage.defaultProps = {
  rounded: true,
}

export default CardImage
